import React, { Component } from 'react';
import { connect } from 'react-redux';
import ChatroomEnquirySettlement from '../Chatroom/ChatroomEnquirySettlement';
import './App.css';
import * as actions from '../../store/actions/index';
import Grid from '@material-ui/core/Grid';
import { withRouter} from 'react-router-dom';
import TeleConferencing from '../../containers/NavTabs/TeleConferencing';
import PaymentTeleconferencing from '../Onboarding/PaymentTeleconferencing';
import ArbitratorAcceptRejectBox from '../NavTabs/ArbitratorAcceptRejectBox'
import CircularProgress from '@material-ui/core/CircularProgress';
import leftIcon from '../../images/left.png'
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";

class EnquirySubmission extends Component {
    
    state = {
        typeOfAccount:localStorage.getItem('typeOfAccount'),
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth,
        uniqueId: localStorage.getItem('token')
    }
    
        handleResize = () => {
        this.setState({
          windowHeight: window.innerHeight,
          windowWidth: window.innerWidth
        })
        console.log('Window Size: window.innerHeight: '+window.innerHeight+' window.innerWidth: '+window.innerWidth+' div 4: '+(window.innerWidth/4))
      } 
    
      componentDidMount() {
        this.handleResize();
        this.props.getCaseInfo(localStorage.getItem('caseId'), localStorage.getItem('token'))
        window.addEventListener('resize', this.handleResize)
        this.checkLanguage()
        
      }

      checkLanguage = function() {
        console.log('Enquiry submission checkLanguage')
        try{
        //   if (this.props.isLoading){
        //     setTimeout(()=>{this.checkLanguage()},100)
        //   }
        //   else{
            console.log('this caseData: '+JSON.stringify(this.props.caseData))
            var lang = localStorage.getItem('language');
            if (this.props !== undefined){
              if (this.props.caseData !== undefined){
                if (this.props.caseData.language !== undefined){
                  if (this.props.caseData.language == 'Chi'){
                    if (lang == 'en' || lang == undefined){
                      localStorage.setItem('language', 'cn');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                  else if (this.props.caseData.language == 'Eng'){
                    if (lang == 'cn' || lang == undefined){
                      localStorage.setItem('language', 'en');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                }
              }
            }
        //   }
        }catch(err){
          setTimeout(()=>{this.checkLanguage()},100)
        }
      }
    
      componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
      }

      returnNormal(){
        if (this.state.windowWidth >= 1220){
            console.log('Hellogx')
            return(
                <div className="App" style={{height: '40%', marginTop: '30px'}} >
                     <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        style={{width:'90vw', display:'block'}}
                    >
                            <Grid
                            item
                            >
                                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                            </Grid>
                            <Grid
                            item
                            style={{display:'flex', justifyContent:'center'}}
                            >
                                {(this.state.typeOfAccount == 'arbitrator') && (this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/> }
                                {(this.state.typeOfAccount == 'arbitrator') && (this.props.caseData.arbitratorStatus == 'true') && <ChatroomEnquirySettlement /> }
                                {(this.state.typeOfAccount !== 'arbitrator') && <ChatroomEnquirySettlement/>}
                            </Grid>
                    </Grid>
    
                </div>
            );
           }
           else if (this.state.windowWidth < 1220){
            console.log('Helloxb')
            return(
                <div className="App" style={{height: '100%', marginTop: '30px', width:'100%'}} >
                     <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        style={{width:'90vw' , display:'block'}}
                    >
                            <Grid
                            item
                            >
                               <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                            </Grid>
                            <Grid
                            item
                            style={{display:'flex', justifyContent:'center'}}
                            >
                               {(this.state.typeOfAccount == 'arbitrator') && (this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/>}
                                {(this.state.typeOfAccount == 'arbitrator') && (this.props.caseData.arbitratorStatus == 'true') && <ChatroomEnquirySettlement /> }
                                {(this.state.typeOfAccount !== 'arbitrator') && <ChatroomEnquirySettlement/>}
                            </Grid>
                        </Grid>
                </div>
            );
           }
           else{
            console.log('Hellowx')
            return(
                <div className="App" style={{height: '100%', marginTop: '30px', width:'100%'}} >
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    style={{width:'auto' , display:'block'}}
                >
                    <Grid
                    item
                    >
                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        style={{width:'90vw' , display:'block'}}
                        >
                            <Grid
                            item
                            style={{display:'flex', justifyContent:'center'}}
                            >
                            {(this.state.typeOfAccount == 'arbitrator') && (this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/>}
                            {(this.state.typeOfAccount == 'arbitrator') && (this.props.caseData.arbitratorStatus == 'true') && <ChatroomEnquirySettlement />  }
                            {(this.state.typeOfAccount !== 'arbitrator') && <ChatroomEnquirySettlement/>}
                            </Grid>
                            </Grid>
                        </Grid>
    
                </div>
            );
           }
      }

      returnWithPayment(){
            if (this.state.windowWidth >= 1220){
                console.log('Hellocx')
                return(
                    <div className="App" style={{height: '100%', width:'100%', marginTop: '30px', marginRight:'30px'}} >
                        
                        {this.state.typeOfAccount == "arbitrator" && (this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/> }
                        {(this.props.caseData.arbitratorStatus == 'true')
                        &&
                        <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        style={{width:'auto' , display:'block'}}
                        >
                            <Grid
                            item
                            >
                                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                            </Grid>
                            <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            style={{width:'90vw' , display:'block'}}
                            >
                            <Grid
                            item
                            style={{display:'flex', justifyContent:'center'}}
                            >
                                <ChatroomEnquirySettlement />
                            </Grid>
                            <Grid
                            item
                            style={{display:'flex', justifyContent:'center'}}
                            >
                                <PaymentTeleconferencing />
                            </Grid>
                            </Grid>
                        </Grid>
                        }
                        {/* {(this.state.typeOfAccount !== 'arbitrator') && <ChatroomEnquirySettlement/>} */}

                    </div>
                );
            }
            else if (this.state.windowWidth < 1220){
                console.log('Helloax')
                return(
                    <div className="App" style={{height: '100%', marginTop: '30px', width:'100%'}} >
                        
                        {this.state.typeOfAccount == "arbitrator" && (this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/>}
                        {(this.props.caseData.arbitratorStatus == 'true') 
                        &&
                        <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        style={{width:'90vw' , display:'block'}}
                        >
                            <Grid
                            item
                            >
                                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                            </Grid>
                            <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            style={{width:'90vw' , display:'block'}}
                            >
                            <Grid
                            item
                            style={{display:'flex', justifyContent:'center'}}
                            >
                                <ChatroomEnquirySettlement />
                            </Grid>
                            <Grid
                            item
                            style={{display:'flex', justifyContent:'center'}}
                            >
                                <PaymentTeleconferencing />
                            </Grid>
                            </Grid>
                        </Grid>
                        }
                        {/* {(this.state.typeOfAccount !== 'arbitrator') && <ChatroomEnquirySettlement/>} */}

                    </div>
                );
            }
            else{
                console.log('Helleox')
                return(
                    <div className="App" style={{height: '100%', marginTop: '30px', width:'100%'}} >
                        
                        {this.state.typeOfAccount == "arbitrator" && (this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/>}
                        {(this.props.caseData.arbitratorStatus == 'true')
                            &&
                            <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            style={{width:'90vw' , display:'block'}}
                            >
                                <Grid
                                item
                                >
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                </Grid>
                                <Grid
                                container
                                direction="column"
                                justifyContent="center"
                                style={{width:'90vw' , display:'block'}}
                                >
                                <Grid
                                item
                                style={{display:'flex', justifyContent:'center'}}
                                >
                                    <ChatroomEnquirySettlement />
                                </Grid>
                                <Grid
                                item
                                style={{display:'flex', justifyContent:'center'}}
                                >
                                    <PaymentTeleconferencing />
                                </Grid>
                                </Grid>
                            </Grid>
                        }
                        {/* {(this.state.typeOfAccount !== 'arbitrator') && <ChatroomEnquirySettlement/>} */}

                    </div>
                );
            }
      }

      returnWithTeleConference(){
        if (this.state.windowWidth >= 1220){
            console.log('Hellox')
            return(
                <div className="App" style={{height: '100%', width:'100%', marginTop: '30px', marginRight:'30px'}} >
                    
                    {this.state.typeOfAccount == "arbitrator" && (this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/> }
                    {(this.props.caseData.arbitratorStatus == 'true')
                    &&
                    <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    style={{width:'auto' , display:'block'}}
                    >
                    <Grid
                        item
                        >
                           <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                        </Grid>
                    <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    style={{width:'90vw' , display:'block'}}
                    >
                        <Grid
                        item
                        style={{display:'flex', justifyContent:'center'}}
                        >
                            <ChatroomEnquirySettlement />
                        </Grid>
                        <Grid
                        item
                        style={{display:'flex', justifyContent:'center'}}
                        >
                            <TeleConferencing />
                        </Grid>
                        </Grid>
                    </Grid>
                    }
                    {/* {(this.state.typeOfAccount !== 'arbitrator') && <ChatroomEnquirySettlement/>} */}

                </div>
            );
        }
        else if (this.state.windowWidth < 1220){
            console.log('Helloxy')
            return(
                <div className="App" style={{height: '100%', marginTop: '30px', width:'100%'}} >
                    
                    {this.state.typeOfAccount == "arbitrator" && (this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/>}
                    {(this.props.caseData.arbitratorStatus == 'true') 
                    &&
                    <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    style={{width:'90vw' , display:'block'}}
                    >
                        <Grid
                            item
                            >
                               <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                            </Grid>
                        <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        style={{width:'90vw' , display:'block'}}
                        >
                            <Grid
                            item
                            style={{display:'flex', justifyContent:'center'}}
                            >
                                <ChatroomEnquirySettlement />
                            </Grid>
                            <Grid
                            item
                            style={{display:'flex', justifyContent:'center'}}
                            >
                                <TeleConferencing mobile={true} />
                            </Grid>
                        </Grid>
                    </Grid>
                    }

                </div>
            );
        }
        else{
            console.log('Helloxz')
            return(
                <div className="App" style={{height: '100%', marginTop: '30px', width:'100%'}} >
                    
                    {(this.state.typeOfAccount == "arbitrator" && this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/>}
                    {(this.props.caseData.arbitratorStatus == 'true')
                        &&
                        <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        style={{width:'90vw' , display:'block'}}
                        >
                        <Grid
                            item
                            >
                            <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                        </Grid>
                        <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        style={{width:'90vw' , display:'block'}}
                        >
                            <Grid
                            item
                            style={{display:'flex', justifyContent:'center'}}
                            >
                                <ChatroomEnquirySettlement />
                            </Grid>
                            <Grid
                            item
                            style={{display:'flex', justifyContent:'center'}}
                            >
                                <TeleConferencing />
                            </Grid>
                        </Grid>
                        </Grid>
                    }
                    {/* {(this.state.typeOfAccount !== 'arbitrator') && <ChatroomEnquirySettlement/>} */}

                </div>
            );
        }
  }

      returnUserView(){
        let userType = '';
        // console.log('returnUserView: '+)
        if (this.props.claimantUniqueId == this.state.uniqueId) {
            userType = 'claimant';
        } else if (this.props.respondentUniqueId == this.state.uniqueId) {
            userType = 'respondent';
        }

        if (userType == 'claimant'){
            if (this.props.caseData.teleconferencingPayment.claimantPaid == false){
                return this.returnWithPayment();
            }
            else if (this.props.caseData.teleconferencingPayment.claimantPaid == true){
                return this.returnWithTeleConference()
            }
        }
        else if (userType == 'respondent'){
            if (this.props.caseData.teleconferencingPayment.respondentPaid == false){
                return this.returnWithPayment();
            }
            else if (this.props.caseData.teleconferencingPayment.respondentPaid == true){
                return this.returnWithTeleConference()
            }
        }
        else{
            return <div></div>
        }

      }

    render(){
        // if(this.props.loadingCaseInfo){
        //     console.log('AN loadingCaseInfo')
        //     return(
        //         <CircularProgress size={50} thickness={3}/>
        //     );
        // }
        // else{ 
            
            if (this.state.typeOfAccount == 'arbitrator' || this.state.typeOfAccount == 'admin'){
                console.log('enquiry and submission arbitrator or admin? '+this.state.typeOfAccount, 'this.state.windowWidth: '+this.state.windowWidth)
                    if (this.state.windowWidth >= 1220){
                        console.log('Hello')
                        return(
                            <div className="App" style={{height: '100%', width:'100%', marginTop: '30px', marginRight:'30px'}} >
                                
                                <br></br>
                                {(this.state.typeOfAccount == "arbitrator" && this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/> }
                                <br></br>
                                {(this.state.typeOfAccount == "arbitrator" && this.props.caseData.arbitratorStatus == 'true')
                                &&
                                <Grid
                                container
                                direction="column"
                                style={{width:'auto', display:'block'}}
                                >
                                    <Grid
                                    item
                                    >
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    </Grid>
                                    <Grid
                                    item
                                    style={{display:'flex', justifyContent:'center'}}
                                    >
                                        <ChatroomEnquirySettlement />
                                    </Grid>
                                    <Grid
                                    item
                                    style={{display:'flex', justifyContent:'center'}}
                                    >
                                        <TeleConferencing />
                                    </Grid>
                                </Grid> }
                                
                                {(this.state.typeOfAccount !== 'arbitrator') && 
                                     <Grid
                                        container
                                        direction="column"
                                        style={{width:'100%', display:'block'}}
                                    >
                                        <Grid
                                            item
                                            >
                                        <Button 
                                            onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        </Grid>
                                        <Grid
                                        item
                                        style={{display:'flex', justifyContent:'center'}}
                                        >
                                            <ChatroomEnquirySettlement />
                                        </Grid>

                                        <Grid
                                        item
                                        style={{display:'flex', justifyContent:'center'}}
                                        >
                                            <TeleConferencing />
                                        </Grid>
                                     </Grid>
                                }

                            </div>
                        );
                    }
                    else if (this.state.windowWidth < 1220){
                        console.log('Hello2')
                        return(
                            <div className="App" style={{height: '100%', marginTop: '30px', width:'100%'}} >
                               
                                <br></br>
                                {(this.state.typeOfAccount == "arbitrator" && this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/>}
                                <br></br>
                                {(this.state.typeOfAccount == "arbitrator" && this.props.caseData.arbitratorStatus == 'true') 
                                &&
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    style={{width:'90vw' , display:'block'}}
                                >
                                    <Grid
                                    item
                                    >
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    </Grid>
                                    <Grid
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        style={{width:'90vw' , display:'block'}}
                                    >
                                        <Grid
                                        item
                                        style={{display:'flex', justifyContent:'center'}}
                                        >
                                            <ChatroomEnquirySettlement />
                                        </Grid>
                                        <Grid
                                        item
                                        style={{display:'flex', justifyContent:'center'}}
                                        >
                                            <TeleConferencing mobile={true} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                }

                                {(this.state.typeOfAccount !== 'arbitrator') && 
                                  <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    style={{width:'90vw' , display:'block'}}
                                    >
                                     <Grid
                                     item
                                     >
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                     </Grid>
                                     <Grid
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        style={{width:'90vw' , display:'block'}}
                                    >

                                     <Grid
                                     item
                                     style={{display:'flex', justifyContent:'center'}}
                                     >
                                         <ChatroomEnquirySettlement />
                                     </Grid>
                                     <Grid
                                     item
                                     style={{display:'flex', justifyContent:'center'}}
                                     >
                                         <TeleConferencing mobile={true} />
                                     </Grid>
                                    </Grid>
                                 </Grid>}

                            </div>
                        );
                    }
                    else if(this.state.windowWidth == undefined) {
                        console.log('Hello3')
                        return(
                            <div className="App" style={{height: '100%', marginTop: '30px', width:'100%'}} >
                                {(this.state.typeOfAccount == "arbitrator" && this.props.caseData.arbitratorStatus == 'waiting') && <ArbitratorAcceptRejectBox/>}
                                {(this.state.typeOfAccount == "arbitrator" && this.props.caseData.arbitratorStatus == 'true')
                                    &&
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        style={{width:'90vw' , display:'block'}}
                                    >
                                        
                                        <Grid
                                        item
                                        >
                                            <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        </Grid>
                                        <Grid
                                        container
                                        direction="column"
                                        justifyContent="center"
                                        style={{width:'90vw' , display:'block'}}
                                    >
                                        <Grid
                                        item
                                        style={{display:'flex', justifyContent:'center'}}
                                        >
                                            <ChatroomEnquirySettlement />
                                        </Grid>
                                        <Grid
                                        item
                                        style={{display:'flex', justifyContent:'center'}}
                                        >
                                            <TeleConferencing />
                                        </Grid>
                                        </Grid>
                                    </Grid>
                                }
                                
                                {(this.state.typeOfAccount !== 'arbitrator') && 
                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="center"
                                    style={{width:'90vw' , display:'block'}}
                                >
                                    <Grid
                                    item
                                    >
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left', display:'block'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    </Grid>
                                    <Grid
                                    container
                                    direction="column"
                                    justifyContent="center"
                                    style={{width:'90vw' , display:'block'}}
                                    >
                                        <Grid
                                        item
                                        style={{display:'flex', justifyContent:'center'}}
                                        >
                                            <ChatroomEnquirySettlement />
                                        </Grid>
                                        <Grid
                                        item
                                        style={{display:'flex', justifyContent:'center'}}
                                        >
                                            <TeleConferencing />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                }

                            </div>
                        );
                    }
            }
            else if (this.state.typeOfAccount == 'user' || this.state.typeOfAccount == 'claimant' || this.state.typeOfAccount == 'respondent'){
                if (this.props.caseData.teleconferencing !== undefined){
                        if (this.props.caseData.teleconferencing){
                            return this.returnUserView()
                        }
                        else{
                            return this.returnNormal();
                        }
                }
                else{
                        return this.returnNormal();
                }
            }
            return null;
        // }
    }

}

const mapStateToProps = (state) => {
    // console.log('mapStateToProps: state: '+JSON.stringify(state));
    return {
        //error: state.caseInfo.error,
        caseData: state.caseInfo.caseData,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        loadingCaseInfo: state.caseInfo.loading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
    }
}

EnquirySubmission.contextTypes = {
    t: PropTypes.func
  }

export default (connect(mapStateToProps, mapDispatchToProps)(withRouter(EnquirySubmission)));